import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "hidden", "maxLength", "size", "error", "full", "helperText", "hideLabel", "subLabelElement", "info", "tooltip", "leadingIcon", "trailingIcon", "leadingElement", "trailingElement", "containerClassName"];
import { forwardRef } from 'react';
import { createFormFieldId } from "../helpers/createFormFieldId";
import { getFormFieldState } from "../helpers/getFormFieldState";
import FormElementContainer from "../shared/FormElementContainer/FormElementContainer";
import FormFieldContainer from "../shared/FormFieldDecoration";
import InputElement from "./components/InputElement";
import { MAX_LENGTH } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var InputField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    hidden = _ref.hidden,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? MAX_LENGTH : _ref$maxLength,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? false : _ref$full,
    helperText = _ref.helperText,
    hideLabel = _ref.hideLabel,
    subLabelElement = _ref.subLabelElement,
    info = _ref.info,
    tooltip = _ref.tooltip,
    leadingIcon = _ref.leadingIcon,
    trailingIcon = _ref.trailingIcon,
    leadingElement = _ref.leadingElement,
    trailingElement = _ref.trailingElement,
    containerClassName = _ref.containerClassName,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  var inputId = createFormFieldId({
    id: id,
    label: label,
    trailing: 'input'
  });
  var fieldState = getFormFieldState({
    disabled: inputProps.disabled,
    error: error
  });
  var draggable = inputProps.draggable,
    onDrag = inputProps.onDrag,
    onDragStart = inputProps.onDragStart,
    onDragEnd = inputProps.onDragEnd;
  var formElementProps = {
    size: size,
    fieldState: fieldState,
    leadingIcon: leadingIcon,
    leadingElement: leadingElement,
    trailingIcon: trailingIcon,
    trailingElement: trailingElement,
    draggable: draggable,
    onDrag: onDrag,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd
  };
  return /*#__PURE__*/_jsx(FormFieldContainer, {
    full: full,
    hidden: hidden,
    childrenId: inputId,
    label: label,
    state: fieldState,
    helperText: helperText,
    hideLabel: hideLabel,
    subLabelElement: subLabelElement,
    info: info,
    size: size,
    tooltip: tooltip,
    containerClassName: containerClassName,
    children: /*#__PURE__*/_jsx(FormElementContainer, _objectSpread({
      formElement: /*#__PURE__*/_jsx(InputElement, _objectSpread({
        ref: ref,
        id: inputId,
        label: label,
        size: size,
        inputState: fieldState,
        maxLength: maxLength
      }, inputProps))
    }, formElementProps))
  });
});
InputField.displayName = 'InputField';
export default InputField;